/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */

import React, { Component } from "react";

import PropTypes from "prop-types";

import _ from "underscore";

// REDUX
import { connect } from "react-redux";
import * as elementsActions from "../../../redux/actions/elements";
import amplitudeAnalytics, {
  AMPLITUDE_NAV_SECTION_SECONDARY,
} from "../../../shared/utilities/amplitude";
import { isBrandRefreshEnabled } from "../../../shared/utilities/brandRefresh";

import styles from "./FullScreenHomepageProductsCategoryFilter.module.css";

class FullScreenHomepageProductsCategoryFilter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isStickyVisible: false,
      originalTop: null,
    };
    this.categoryElement = React.createRef();
    this.lastScrollTop = 0;
    this.isScrollingDown = false;
  }

  componentDidMount() {
    const { isStickyCategories, onStickyVisibilityChange } = this.props;
    if (!isStickyCategories) setTimeout(this.getComponentPosition, 500);
    window.addEventListener("resize", this.getComponentPosition); // eslint-disable-line

    window.addEventListener("scroll", this.handleScroll);
    this.syncCategoryNavigationHandler();
    if (onStickyVisibilityChange) {
      onStickyVisibilityChange(false, true);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { productCategory, mobileDarkTheme } = this.props;
    if (
      prevProps.productCategory !== productCategory ||
      prevProps.mobileDarkTheme !== mobileDarkTheme
    ) {
      this.getComponentPosition();
    }
    const { isStickyVisible } = this.state;
    const { prevStickyVisible } = prevState;
    if (prevStickyVisible !== isStickyVisible) {
      const { onStickyVisibilityChange } = this.props;
      if (onStickyVisibilityChange) {
        onStickyVisibilityChange(isStickyVisible);
      }
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.getComponentPosition);
    window.removeEventListener("scroll", this.handleScroll);
    this.syncCategoryNavigationHandler(null);
  }

  handleScroll = () => {
    if (!this.categoryElement.current) return;

    const { originalTop, isStickyVisible } = this.state;

    if (originalTop === null) {
      const rect = this.categoryElement.current.getBoundingClientRect();
      const scrollTop = window.pageYOffset;
      this.setState({ originalTop: rect.top + scrollTop });
      return;
    }

    const scrollTop = window.pageYOffset;
    // Brand refresh nav is 64px; with ribbon it's 100px (64 + 36).
    // The ribbon hides when scrolling down, so use 64 as the base for
    // zone detection — once we're past the categories, the ribbon is gone
    // and the sticky filter sits at top:0.
    const { persistentNavigation, navigationHeight } = this.props;
    const headerHeight = persistentNavigation ? navigationHeight : 64;
    const isScrollingDown = scrollTop > this.lastScrollTop;
    const currentlyInZone2 = scrollTop + headerHeight > originalTop;

    if (scrollTop + headerHeight <= originalTop) {
      if (isStickyVisible) {
        this.lastScrollTop = scrollTop;
        this.isScrollingDown = isScrollingDown;
        this.setState({ isStickyVisible: false });
        const { onStickyVisibilityChange } = this.props;
        if (onStickyVisibilityChange) {
          onStickyVisibilityChange(false, true);
        }
      } else {
        this.lastScrollTop = scrollTop;
        this.isScrollingDown = isScrollingDown;
      }
    } else if (!isStickyVisible) {
      this.lastScrollTop = scrollTop;
      this.isScrollingDown = isScrollingDown;
      this.setState({ isStickyVisible: true });
    } else {
      this.lastScrollTop = scrollTop;
      this.isScrollingDown = isScrollingDown;
    }

    const navShouldBeVisible = persistentNavigation || !currentlyInZone2 || !isScrollingDown;

    if (currentlyInZone2) {
      const { onStickyVisibilityChange } = this.props;
      if (onStickyVisibilityChange) {
        onStickyVisibilityChange(isStickyVisible, navShouldBeVisible);
      }
    }
  };

  getComponentPosition = () => {
    const { setCategoriesPosition } = this.props;
    if (this.categoryElement.current) {
      const { top } = this.categoryElement.current.getBoundingClientRect();
      setCategoriesPosition(top + window.pageYOffset); // eslint-disable-line
    }
  };

  returnIconAsset = product => {
    const iconAlt = `${product}-icon`;
    let iconAsset = null;

    try {
      iconAsset = require(`../imgs/${product}.png`) || null; //eslint-disable-line
    } catch (e) {
      iconAsset = require("../imgs/boxes.png"); //eslint-disable-line
    }

    return <img alt={iconAlt} src={iconAsset} className="hidden lg:block" />;
  };

  syncCategoryNavigationHandler = (
    handler = this.handleRegisteredCategoryNavigation
  ) => {
    const { registerCategoryNavigationHandler } = this.props;
    if (registerCategoryNavigationHandler) {
      registerCategoryNavigationHandler(handler);
    }
  };

  getMenuCategories = () => {
    const { menuCategories } = this.props;
    return Array.isArray(menuCategories) ? menuCategories : [];
  };

  handleRegisteredCategoryNavigation = (anchor, options = {}) => {
    return this.handleCategoryValueSetting(anchor, null, {
      trackAnalytics: false,
      ...options,
    });
  };

  handleCategoryValueSetting = (anchor, e, options = {}) => {
    if (e) {
      e.preventDefault();
    }
    const element = document.getElementById(anchor); // eslint-disable-line
    if (!element) {
      return false;
    }
    const { onChange, setProductCategory, location } = this.props;
    const menuCategories = this.getMenuCategories();
    const category = menuCategories.find(item => item.anchor === anchor);
    if (options.trackAnalytics !== false) {
      amplitudeAnalytics.trackClickNavSecondary({
        navElement: category?.navTitle || anchor,
        navSection: AMPLITUDE_NAV_SECTION_SECONDARY.CATEGORIES,
        pathname: location?.pathname,
      });
    }
    setProductCategory(anchor);
    onChange(anchor);
    const categoryHeight = this.categoryElement.current
      ? this.categoryElement.current.getBoundingClientRect().height
      : 10;
    let scrollDelta = window.innerWidth > 900 ? categoryHeight : 92;
    const { persistentNavigation, navigationHeight } = this.props;
    if (persistentNavigation) {
      // Becoming fixed removes the category bar from document flow. Account
      // for that shift on the first jump, as well as the persistent top nav.
      const { isStickyVisible } = this.state;
      scrollDelta += navigationHeight + (isStickyVisible ? 0 : categoryHeight);
    }
    const yPos = element ? element.offsetTop - scrollDelta : null;
    const behavior = options.behavior || "smooth";
    if (yPos || yPos === 0) {
      window.scrollTo({ top: yPos, left: 0, behavior }); // eslint-disable-line
    }
    return true;
  };

  render() {
    const { productCategory, mobileDarkTheme } = this.props;
    const menuCategories = this.getMenuCategories();
    const { isStickyVisible } = this.state;
    const alteredMenucategories = _.uniq(menuCategories, item => {
      return item.navTitle;
    });

    const brandRefresh = isBrandRefreshEnabled();
    const getCategoryTitleClass = (sticky, chosen) => {
      if (sticky) {
        return chosen
          ? "font-bold text-white"
          : "font-medium text-white";
      }
      let className;
      if (chosen) {
        className = "font-bold dark:font-bold";
      } else if (brandRefresh) {
        className = "font-medium dark:font-medium";
      } else {
        className = "font-[425] dark:font-[425] opacity-60";
      }
      return className;
    };

    return (
      <div
        ref={this.categoryElement}
        className={`${styles.categoryFilterWrapper} ${
          mobileDarkTheme ? styles.mobileDarkTheme : null
        } flex items-center m-auto`}
      >
        <div
          className={`
                ${styles.categoryFilterContainer} 
                p-0 m-0 flex justify-between w-full font-montserratMedium text-lg leading-[22px] tracking-[-0.1px]
                `}
        >
          {alteredMenucategories
            ? alteredMenucategories.map((mc, index) => {
                const customIcon = index === 4 || index === 5;
                const isChosen = mc.anchor === productCategory;
                let linkTextColorClass;
                if (mobileDarkTheme || isStickyVisible) {
                  linkTextColorClass = "text-white dark:border-[#F6F3F7]";
                } else if (brandRefresh) {
                  linkTextColorClass = "text-[#F1E8DE] dark:text-[#F1E8DE]";
                } else {
                  linkTextColorClass = "dark:text-white text-dark dark:border-[#F6F3F7] border-dark";
                }

                return (
                  <a
                    key={`$product${Math.random()}`}
                    id={`menuCategorySelector-${mc.anchor}`}
                    href={`#${mc.anchor}`}
                    onClick={e => this.handleCategoryValueSetting(mc.anchor, e)}
                    onKeyDown={e => {
                      if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault();
                        this.handleCategoryValueSetting(mc.anchor, e);
                      }
                    }}
                    className={`
                                rounded-none
                                ease-in
                                ${linkTextColorClass}
                                ${brandRefresh ? "" : "px-2"}

                                ${styles.category}
                                ${customIcon ? styles.customIcon : null}
                                ${isChosen ? styles.isChosen : null}
                            `}
                    aria-label={`Navigate to ${mc.navTitle} section`}
                  >
                    <h3
                      className={getCategoryTitleClass(
                        isStickyVisible,
                        isChosen
                      )}
                    >
                      {mc.navTitle}
                    </h3>
                  </a>
                );
              })
            : null}
        </div>
      </div>
    );
  }
}

FullScreenHomepageProductsCategoryFilter.propTypes = {
  persistentNavigation: PropTypes.bool,
  navigationHeight: PropTypes.number,
  productCategory: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  setProductCategory: PropTypes.func.isRequired,
  mobileDarkTheme: PropTypes.bool,
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }),
  setCategoriesPosition: PropTypes.func,
  isStickyCategories: PropTypes.bool,
  onStickyVisibilityChange: PropTypes.func,
  registerCategoryNavigationHandler: PropTypes.func,
  menuCategories: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string,
      cardSize: PropTypes.string,
      navTitle: PropTypes.string,
      menuTitle: PropTypes.string,
      anchor: PropTypes.string
    })
  )
};

FullScreenHomepageProductsCategoryFilter.defaultProps = {
  persistentNavigation: false,
  navigationHeight: 64,
  mobileDarkTheme: false,
  setCategoriesPosition: null,
  isStickyCategories: false,
  productCategory: null,
  menuCategories: [],
  location: undefined,
  onStickyVisibilityChange: null,
  registerCategoryNavigationHandler: null
};

export const mapStateToProps = state => {
  const {
    productCategory,
    isStickyCategories,
    menuCategories
  } = state.elements;
  return {
    productCategory,
    isStickyCategories,
    menuCategories
  };
};

export const mapDispatchToProps = dispatch => ({
  setProductCategory: value =>
    dispatch(elementsActions.setProductCategory(value)),
  setCategoriesPosition: value =>
    dispatch(elementsActions.setCategoriesPosition(value))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FullScreenHomepageProductsCategoryFilter);
